module.exports = "<h4 class=\"bg-{{color}}\">lorem ipsum (h4) - bg-{{color}}</h4>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_titles_bg.html
// module id = 113
// module chunks = 0